import React, {Component} from "react";
import {UncontrolledCollapse} from "reactstrap";

interface Props {
    question: string;
    answer: JSX.Element;
    index: number;
}

export default class FaqItem extends Component<Props> {
    render(): JSX.Element {
        return (
            <div className="anywhereTab__faq__item">

                <UncontrolledCollapse className="anywhereTab__faq__drawer" toggler={`#faq${this.props.index}`}>
                    <p>
                        {this.props.answer}
                    </p>
                </UncontrolledCollapse>

                <p id={`faq${this.props.index}`}>
                    {this.props.question}
                </p>

            </div>
        );
    }
}